import { DatelyObject, Numeric, Years } from "../../util";
import { DailyAllowanceKind, DailyAllowanceUsecase, UserDefinedRow } from "../../model";
import { UsecaseValidationMessage } from "../UsecaseValidationMessage";
import { EnumerationsLogic, Translations } from "../../logic";
import { BaseUsecaseLogic } from "../BaseUsecaseLogic";

/** Client-side logic for Daily allowance  */
export class DailyAllowanceUsecaseLogic extends BaseUsecaseLogic {

  /**
   * Updates the usecase values based on user input without going to the server.
   * @param row Row to update.
   * @param date The reference date for which the logic is done.
   * Typically the salary date of a calculation and the typically, the information needed is just the year for which the yearly changing numbers are fetched, but may later have more extended features.
   */
  public updateUsecase(row: UserDefinedRow, date: DatelyObject): void {
    const data: DailyAllowanceUsecase = row.data;
    switch (data.kind) {
      case DailyAllowanceKind.FullDailyAllowance:
        row.price = Years.getYearlyChangingNumbers(date).sideCosts.taxFreeDailyAllowance; // 43;
        break;
      case DailyAllowanceKind.PartialDailyAllowance:
        row.price = Years.getYearlyChangingNumbers(date).sideCosts.taxFreeDailyHalfAllowance; // 20;
        break;
      case DailyAllowanceKind.MealAllowance:
        row.price = Years.getYearlyChangingNumbers(date).sideCosts.taxFreeMealAllowance; // 10.75;
        break;
      case DailyAllowanceKind.InternationalDailyAllowance:
        if (data.country) {
          const countryPrice = Years.getYearlyTaxFreeNumbers(date).countries[data.country];
          if (countryPrice) {
            row.price = countryPrice;
          }
        }
        break;
      case DailyAllowanceKind.Undefined:
      default:
        // Not known
        break;
    }
    if (row.price && data.isHalf) {
      row.price = Numeric.round(row.price / 2);
    }
  }

  /** Gets validation message for Daily allowance  */
  public getUcValidation(row: UserDefinedRow): UsecaseValidationMessage {
    const data: DailyAllowanceUsecase = row.data || {};
    let msg;
    switch (data.kind) {
      case DailyAllowanceKind.PartialDailyAllowance:
      case DailyAllowanceKind.MealAllowance:
        msg = EnumerationsLogic.getEnumLabel("DailyAllowanceKind", data.kind);
        break;
      case DailyAllowanceKind.InternationalDailyAllowance: {
        msg = EnumerationsLogic.getEnumLabel("DailyAllowanceKind", data.kind);
        const country = Years.getYearlyTaxFreeNumbers("today").countries[data.country];
        if (country) {
          msg = msg + ` (${Translations.get(`SALAXY.CORE.yearlyTaxfreeYears.countries.${data.country}`)})`;
        }
        break;
      }
      case DailyAllowanceKind.Undefined:
      default:
        msg = "SALAXY.VALIDATION.Usecases.dailyAllowance";
        break;
    }
    return { type: "default", msg };
  }
}
